export default __webpack_public_path__ + "static/media/HangmanGame.56139cc7.jpg";